import React from 'react';
import { Alert, Box, Button, Typography } from '@mui/material';
import { PRES, TYPE } from '../chrome';
import { COPY } from '../presentationCopy';

interface GenerateAiBannerProps {
  busy?: boolean;
  onRegenerate: () => void;
  onDelete: () => void;
}

const GenerateAiBanner: React.FC<GenerateAiBannerProps> = ({ busy, onRegenerate, onDelete }) => (
  <Box sx={{ px: 1.5, pt: 1 }}>
    <Alert
      severity="info"
      action={(
        <Box sx={{ display: 'flex', gap: 0.5 }}>
          <Button color="inherit" size="small" disabled={busy} onClick={onRegenerate} sx={{ textTransform: 'none' }}>
            {COPY.aiGeneratedRegenerate}
          </Button>
          <Button color="inherit" size="small" disabled={busy} onClick={onDelete} sx={{ textTransform: 'none' }}>
            {COPY.aiGeneratedDelete}
          </Button>
        </Box>
      )}
    >
      <Typography sx={{ fontFamily: TYPE.ui, ...TYPE.body, color: PRES.textPrimary }}>
        {COPY.aiGeneratedBanner}
      </Typography>
    </Alert>
  </Box>
);

export default GenerateAiBanner;
